if (!customElements.get('jc-featured-blog')) {
  customElements.define(
    'jc-featured-blog',
    class JCFeaturedBlog extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.jc-featured-blog__row');
        this.cards = this.querySelectorAll('.jc-featured-blog__card');
        this.prevBtn = this.querySelector('[data-carousel-prev]');
        this.nextBtn = this.querySelector('[data-carousel-next]');

        this.prevBtn?.addEventListener('click', () => this.scrollByCard(-1));
        this.nextBtn?.addEventListener('click', () => this.scrollByCard(1));
      }

      scrollByCard(direction) {
        const card = this.cards[0];
        if (!card || !this.track) return;

        const gap = Number.parseFloat(getComputedStyle(this.track).columnGap) || 0;
        this.track.scrollBy({ left: direction * (card.offsetWidth + gap), behavior: 'smooth' });
      }
    }
  );
}
